<script setup lang="ts">
import type { ExtendedItem } from "@/interfaces";

interface Props {
  model: string;
  item: ExtendedItem;
  groupId: string;
  enableIcon?: boolean;
}

withDefaults(defineProps<Props>(), {
  enableIcon: true,
});

defineEmits(["update"]);
</script>

<template>
  <button
    type="button"
    class="dropdown-focusable-item px-4 py-4 rounded-lg flex items-center w-full justify-start focus-visible-strong"
    :class="[
      model === item.value ? 'bg-darkOcean50' : '',
      item.disabled ? 'text-neutral500' : '',
      !item.disabled ? 'hover:bg-neutral50 active:bg-neutral100' : '',
      `dropdown-group-${groupId}`,
    ]"
    @click="$emit('update', item.value)"
    :disabled="item.disabled"
  >
    <div v-if="enableIcon" class="flex justify-center items-center w-9 mr-1">
      <i
        v-if="model === item.value"
        class="fa fa-check text-darkOcean500 text-xl"
      />
    </div>
    <div class="w-full text-left overflow-auto time-content">
      {{ item.title }}
    </div>
  </button>
</template>
